export default "<app-opportunities-list></app-opportunities-list>\r\n";